export const ChatSpotTypeDecorator = {
  url() {
    return `signup-hubspot/chatspot`;
  },

  query() {
    return {};
  }

};